import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import RoleBasedRoute from './components/RoleBasedRoute';
import { AuthProvider } from './contexts/AuthContext';
import MainLayout from './layouts/MainLayout';
import Accesorios from './pages/Accesorios';
import Ajustes from './pages/Ajustes';
import Bicicletas from './pages/Bicicletas';
import Calendario from './pages/Calendario';
import Categorias from './pages/Categorias';
import Clientes from './pages/Clientes';
import Contratos from './pages/Contratos';
import DiasCerrados from './pages/DiasCerrados';
import EmailPreview from './pages/EmailPreview';
import EntregasRecogidas from './pages/EntregasRecogidas';
import PreparacionReservas from './pages/PreparacionReservas';
import Home from './pages/Home';
import Informes from './pages/Informes';
import Login from './pages/Login';
import Mantenimiento from './pages/Mantenimiento';
import MiCuenta from './pages/MiCuenta';
import Models from './pages/Models';
import PreciosEstacionales from './pages/PreciosEstacionales';
import Reservas from './pages/Reservas';
import Temporadas from './pages/Temporadas';
import Usuarios from './pages/Usuarios';
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Ruta pública de login - página independiente */}
          <Route path="/login" element={<Login />} />
          
          {/* Rutas protegidas con layout completo */}
          <Route path="/" element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            {/* Ruta de inicio - redirige AGENCY a reservas */}
            <Route index element={
              <RoleBasedRoute>
                <Home />
              </RoleBasedRoute>
            } />
            
            {/* Rutas solo para usuarios no-AGENCY */}
            <Route path="calendario" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Calendario />
              </RoleBasedRoute>
            } />
            <Route path="bicicletas" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Bicicletas />
              </RoleBasedRoute>
            } />
            <Route path="models" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Models />
              </RoleBasedRoute>
            } />
            <Route path="categorias" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Categorias />
              </RoleBasedRoute>
            } />
            <Route path="temporadas" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Temporadas />
              </RoleBasedRoute>
            } />
            <Route path="precios-estacionales" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <PreciosEstacionales />
              </RoleBasedRoute>
            } />
            {/* Actividades (buggies / parasailing / jet ski) desactivadas: redirige al inicio */}
            <Route
              path="actividades"
              element={
                <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                  <Navigate to="/" replace />
                </RoleBasedRoute>
              }
            />
            <Route
              path="actividades/:group"
              element={
                <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                  <Navigate to="/" replace />
                </RoleBasedRoute>
              }
            />
            <Route path="entregas-recogidas" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <EntregasRecogidas />
              </RoleBasedRoute>
            } />
            <Route path="preparacion-dia" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <PreparacionReservas />
              </RoleBasedRoute>
            } />
            <Route path="accesorios" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Accesorios />
              </RoleBasedRoute>
            } />
            <Route path="clientes" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Clientes />
              </RoleBasedRoute>
            } />
            <Route path="mantenimiento" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Mantenimiento />
              </RoleBasedRoute>
            } />
            <Route path="usuarios" element={
              <RoleBasedRoute allowedRoles={['ADMIN']}>
                <Usuarios />
              </RoleBasedRoute>
            } />
            <Route path="dias-cerrados" element={
              <RoleBasedRoute allowedRoles={['ADMIN']}>
                <DiasCerrados />
              </RoleBasedRoute>
            } />
            <Route path="informes" element={
              <RoleBasedRoute allowedRoles={['ADMIN']}>
                <Informes />
              </RoleBasedRoute>
            } />
            <Route path="contratos" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Contratos />
              </RoleBasedRoute>
            } />
            <Route path="ajustes" element={
              <RoleBasedRoute allowedRoles={['ADMIN', 'STAFF', 'TECHNICIAN']}>
                <Ajustes />
              </RoleBasedRoute>
            } />
            
            {/* Rutas accesibles para todos los roles autenticados */}
            <Route path="reservas" element={<Reservas />} />
            <Route path="mi-cuenta" element={<MiCuenta />} />
            <Route path="email-preview" element={<EmailPreview />} />
          </Route>
          
          {/* Redirigir cualquier ruta no encontrada al login */}
          <Route path="*" element={<Login />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
